
import { enqueueSnackbar } from "notistack";
import axiosInstance from "src/utils/axios";
import localStorageAvailable from "src/utils/localStorageAvailable";

const getZeroPackages = async (
  user,
  event
) => {
  const storageAvailable = localStorageAvailable();

  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";


  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `/service/events_service/v1/events/wa/list/${event}`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
  };
  try {
    const response = await axiosInstance.request(config);
    return response?.data;
  } catch (error) {
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    if (error?.data === "Verification timeout") {
      return;
    }
    enqueueSnackbar(error?.data?.message || error?.data, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default getZeroPackages;
